import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-access-unauthorized',
  imports: [RouterLink],
  template: `
    <div class="mx-auto max-w-xl py-6">
      <div class="flex flex-col items-center rounded-xl bg-white p-8 shadow-md">
        <h1>Access Denied</h1>
        <p class="pb-8 pt-4 text-xl">
          You do not have permission to view this page.
        </p>
        <button class="btn-primary" routerLink="/">Go to Home</button>
      </div>
    </div>
  `,
})
export class AccessUnauthorizedComponent {}
